import ar from "@/assets/locales/ar.json";
import bg from "@/assets/locales/bg.json";
import bn from "@/assets/locales/bn.json";
import ca from "@/assets/locales/ca@valencia.json";
import cs from "@/assets/locales/cs.json";
import da from "@/assets/locales/da.json";
import de from "@/assets/locales/de.json";
import el from "@/assets/locales/el.json";
import en from "@/assets/locales/en.json";
import es from "@/assets/locales/es.json";
import et from "@/assets/locales/et.json";
import fa from "@/assets/locales/fa.json";
import fi from "@/assets/locales/fi-FI.json";
import fr from "@/assets/locales/fr.json";
import gl from "@/assets/locales/gl.json";
import gu from "@/assets/locales/gu.json";
import he from "@/assets/locales/he.json";
import hi from "@/assets/locales/hi.json";
import id from "@/assets/locales/id.json";
import is from "@/assets/locales/is-IS.json";
import it from "@/assets/locales/it.json";
import ja from "@/assets/locales/ja.json";
import ko from "@/assets/locales/ko.json";
import lv from "@/assets/locales/lv.json";
import minion from "@/assets/locales/minion.json";
import ne from "@/assets/locales/ne.json";
import nl from "@/assets/locales/nl.json";
import nv from "@/assets/locales/nv.json";
import pa from "@/assets/locales/pa.json";
import pirate from "@/assets/locales/pirate.json";
import pl from "@/assets/locales/pl.json";
import ptBR from "@/assets/locales/pt-BR.json";
import ptPT from "@/assets/locales/pt-PT.json";
import ro from "@/assets/locales/ro.json";
import ru from "@/assets/locales/ru.json";
import sl from "@/assets/locales/sl.json";
import sv from "@/assets/locales/sv.json";
import ta from "@/assets/locales/ta.json";
import th from "@/assets/locales/th.json";
import tok from "@/assets/locales/tok.json";
import tr from "@/assets/locales/tr.json";
import uk from "@/assets/locales/uk.json";
import vi from "@/assets/locales/vi.json";
import zhHant from "@/assets/locales/zh-Hant.json";
import zhHans from "@/assets/locales/zh.json";

export const locales = {
  ar,
  bg,
  bn,
  "ca-ES": ca,
  cs,
  da,
  de,
  el,
  en,
  es,
  et,
  fa,
  "fi-FI": fi,
  fr,
  gl,
  gu,
  he,
  hi,
  id,
  "is-IS": is,
  it,
  ja,
  ko,
  lv,
  minion,
  ne,
  nl,
  nv,
  pa,
  pirate,
  pl,
  "pt-BR": ptBR,
  "pt-PT": ptPT,
  ro,
  ru,
  sl,
  sv,
  ta,
  th,
  tok,
  tr,
  uk,
  vi,
  "zh-Hans": zhHans,
  "zh-Hant": zhHant,
} as const;

export type Locales = keyof typeof locales;

export const languages = {
  "ar-SA": "العربية",
  "ca-ES": "Català (Valencià)",
  "de-DE": "Deutsch",
  el: "Ελληνικά",
  en: "English",
  es: "Español",
  "fi-FI": "Suomi",
  fr: "Français",
  he: "עברית",
  "hi-IN": "हिंदी",
  id: "Bahasa Indonesia",
  it: "Italiano",
  ja: "日本語",
  ko: "한국어",
  nl: "Nederlands",
  no: "Norsk",
  pl: "Polski",
  "pt-BR": "Português (Brasil)",
  "pt-PT": "Português (Portugal)",
  ru: "Русский",
  "sv-SE": "Svenska",
  th: "ไทย",
  tr: "Türkçe",
  uk: "Українська",
  vi: "Tiếng Việt",
  "zh-Hans": "简体中文",
  "zh-Hant": "繁體中文",
} as const;
